import { render, staticRenderFns } from "./ControlComponentWrapper.vue?vue&type=template&id=12b4f98a&"
import script from "./ControlComponentWrapper.vue?vue&type=script&lang=ts&"
export * from "./ControlComponentWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports